import * as React from "react";
const SvgFiRrPointOfSaleBill = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-point-of-sale-bill_svg__a)">
      <path
        fill="#062147"
        d="M11 10v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1m13-3.5V17a.998.998 0 0 1-1.499.866l-2.17-1.25-1.767 1.209a.996.996 0 0 1-1.389-.261 1 1 0 0 1 .261-1.39l2.285-1.564a1 1 0 0 1 1.063-.041l1.216.7V6.5C22 4.019 19.981 2 17.5 2a4.46 4.46 0 0 0-4.431 3.815A4.5 4.5 0 0 1 15 9.5v10c0 2.481-2.019 4.5-4.5 4.5h-6A4.505 4.505 0 0 1 0 19.5v-10c0-1.557.795-2.93 2-3.738V5c0-2.757 2.243-5 5-5h10.5C21.084 0 24 2.916 24 6.5m-11 3C13 8.121 11.879 7 10.5 7h-6A2.5 2.5 0 0 0 2 9.5v10C2 20.879 3.121 22 4.5 22h6c1.379 0 2.5-1.121 2.5-2.5zm-1.836-4.433A6.45 6.45 0 0 1 12.799 2H7C5.346 2 4 3.346 4 5v.051c.166-.019.329-.051.5-.051h6c.227 0 .446.034.664.067M10 14H9a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2m0 4H9a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2m-4-4H5a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2m0 4H5a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-point-of-sale-bill_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPointOfSaleBill;
